import React, { useState } from 'react'
import router from 'next/router'
import styles from '../../styles/modules/components/SelfServe/selfserve-modal.module.scss';
import commonStyles from '../../styles/modules/components/SelfServe/phone-input-step.module.scss';
import Button from '../common/ui-components/input/Button';
import UIModal from '../common/ui-components/surface/UIModal';
import UIDropdown from '../common/ui-components/input/UIDropdown/UIDropdown';
import UITextArea from '../common/ui-components/input/UITextArea';
import { useDispatch, connect } from 'react-redux'
import {
    updateSrReopenReason, updateSelectedProblems,
    changeLandedOnPage, changeAddressPageFrom,
    updateCustomIssue, removeSelectedCover, pushToTicketList
} from '../../redux/actions/selfserveActions';
import {changeProgress} from '../../redux/actions/selfserveActions';
import { reopenSR } from '../../tracking/selfserveTracking';
import { HOMECARE_PLANS, HOMECARE_PLAN_LIST } from '../../constants/index';
import { cleverTapTrigger } from '../../tracking/segment';

const ReopenRequestAlert = (props: any) => {
    const dispatch:any = useDispatch();
    const [reopen, changeReopen] = useState(false);
    const [issue, setIssue] = React.useState<any>(null)
    const [comment, setComment] = React.useState<string>("")
    const [errorIssue, setErrorIssue] = React.useState<string>("")
    const [issueBorder, setIBorder] = React.useState<boolean>(true)

    const {  parentPlanDetails } = props.selfserveReducer

    const titleText = !reopen ? "Wait a minute..." : "Reopening a Service Request?"
    const bodyText = !reopen
        ? HOMECARE_PLANS.includes(parentPlanDetails.plan_name)
            ? "We see that you have already raised a Service Request within last 90 days. Would you like to reopen it?"
            : "We see that you have already raised a Service Request within last 30 days. Would you like to reopen it?"
        : "Please select a reason for reopening"

    const removeCover = () => {
        dispatch(updateSelectedProblems({index: 0, selectedProblems: []}));
        const data = {
            index: 0
        }
        dispatch(removeSelectedCover(data));
        close();
    }
    const close = () => {
        // changeOpen(false)
        if(Object.keys(router.query).length!==0 && router.query?.osid)
        {
            window.location.href = window.location.pathname
        }
        else
        {
            changeReopen(false);
            props.closeModal(false)
        }
        return false
    }
    const reopenRequest = () => {
        reopenSR(); //gtm tracking event
        changeReopen(true)
    }

    // const raiseNewRequest = () => {
    //     // changeOpen(false)
    //     props.closeModal(false)
    //     window.alert('we are raising new request')
    // }

    const handleSelect = (e) => {
        setErrorIssue("")
        setIBorder(true)
        setIssue(e["value"])
        return false
    }

    const handleSelectComment = (e) => {
        setComment(e.target.value)
    }

    const options: any[] = [
        {
            text: "Problem is not resolved/still existing",
            value: "Problem is not resolved/still existing",
            key: 1,
        },
        {
            text: "New issues arise with previous repairs",
            value: "New issues arise with previous repairs",
            key: 2,
        },
        {
            text: "Cosmetic damage during the repair",
            value: "Cosmetic damage during the repair",
            key: 3,
        },
        {
            text: "Others",
            value: "Others",
            key: 4,
        },
    ]

    const onSubmit = (e) => {
        if (issue === null) {
            setIBorder(false)
            setErrorIssue("Required fields")
        }
        else {
            e.preventDefault()
            dispatch(updateCustomIssue({index: 0, custom_issue:''}));
            const reopenReasonData: any = { 'reason': issue, 'comment': comment, 'index': 0 }
            dispatch(updateSrReopenReason(reopenReasonData))

            if(issue === 'Problem is not resolved/still existing'){
                dispatch(changeAddressPageFrom(props.selfserveReducer.current_step));
                if (props.selfserveReducer.urlLanded) {
                    dispatch(changeLandedOnPage('address'))
                }
                // const existingProblemData: any = {'index': 0, 'selectedProblems': props.planDetail.old_data.old_problems[0].split(',')}
                const existingProblemData: any = {'index': 0, 'selectedProblems': props.selfserveReducer.serviceRequests[0].selected_cover?.cover_details[0].last_sr_problems ? props.selfserveReducer.serviceRequests[0].selected_cover.cover_details[0].last_sr_problems[0].split(',') : []}

                dispatch(updateSelectedProblems(existingProblemData))
                //check this scenario
                if(HOMECARE_PLAN_LIST.includes(parentPlanDetails.plan_name)){
                    dispatch(pushToTicketList());
                    dispatch(changeProgress(15));
                }else{
                    dispatch(changeProgress(7));
                }

                changeReopen(false);
                props.closeModal(false)
            }
            else{
                if(props.selfserveReducer.serviceRequests[0].hasOwnProperty('sr_reopen_reason') && props.selfserveReducer.serviceRequests[0].sr_reopen_reason !== issue){
                    dispatch(updateSelectedProblems({'index': 0, 'selectedProblems': []}));
                }
                if (props.selfserveReducer.urlLanded) {
                    dispatch(changeLandedOnPage('issues'))
                }
                dispatch(changeProgress(5,true));
                changeReopen(false);
                props.closeModal(false)
            }
            return false
        }
    }
    React.useEffect(()=>{
        if(props.is_open){
            cleverTapTrigger('SR Reopen Pop-up Displayed', {'osid':props.osid, 'category': props.selfserveReducer?.planDetails?.category, 'product_type': props.selfserveReducer?.planDetails?.product_type})
        }
    },[props?.is_open])

    return (
        <UIModal isOpen={props.is_open} onClick={removeCover} larger={false} boxClass={styles.apply_box}>
            {!reopen &&
                <div className={styles.selfserve_alert}>
                <h5 className={styles.selfserve_alert__title}>{titleText}</h5>
                <div className={styles.selfserve_alert__text}>
                    <p>{bodyText}</p>
                </div>

                <div className={commonStyles.customButton} >
                    <Button
                        onClick={removeCover}
                        text="Cancel"
                        variant="secondary"
                        className={commonStyles.btn_single}
                        style={{'fontSize': '14px'}}
                    />
                    <Button
                        onClick={reopenRequest}
                        text="Yes, Reopen the Request"
                        className={commonStyles.btn_single}
                        style={{'fontSize': '14px'}}
                    />
                </div>

                {/* <div className={styles.raise_query_buttons}>

                    <Button
                        onClick={close}
                        text="Cancel"
                        variant="secondary"
                        className={styles.raise_query_buttons__button}
                    />
                    <Button
                        onClick={reopenRequest}
                        text="Yes, Reopen the Request"
                        className={styles.raise_query_buttons__button}
                    />
                </div> */}
                </div>
            }
                {reopen &&
                    <form method="POST" action="#" className={styles.form_wrap}>
                        <h6>Reopening a Service Request?</h6>
                        <p>Please select a reason for reopening the request</p>

                        <div className={styles.input_wrap}>
                            <div className={styles.selfserve_dropdown}><UIDropdown isRequired={true} className={issueBorder ? `${styles.bordering}` : `${styles.bordering__error}`} propsError={errorIssue} options={options} selected_option={issue === null ? null : { text: issue, value: issue, key: issue }} placeholder="Select Issue" onChange={(e: React.ChangeEvent<{}>) => handleSelect(e)} /> </div>


                            <div className={styles.selfserve_text_area}>
                                <UITextArea noPlaceholder={false} label="Comments" className={`${styles.formdiv__textfield}`} value={comment} onChange={(e: any) => handleSelectComment(e)} />

                            </div>

                            <div className={`${commonStyles.button_actions_sticky} ${styles.reopen_buttons}`} data-varient='non-sticky'>
                                <Button
                                    onClick={close}
                                    text="Cancel"
                                    variant="secondary"
                                    className={commonStyles.cart_btn}
                                    style={{'fontSize': '14px'}}
                                />
                                <Button
                                    text="Submit"
                                    onClick={(e: React.ChangeEvent<{}>) => onSubmit(e)}
                                    className={commonStyles.cart_btn}
                                    style={{'fontSize': '14px'}}
                                />

                            </div>
                        </div>
                    </form>
                }

        </UIModal>
    )
}

const mapStateToProps = (state:any) => {
    return {
        selfserveReducer:state.selfserveReducer,
    }
}

export default connect(mapStateToProps) (ReopenRequestAlert);